'use strict';

const Enum = require('./enum');

/**
 * Defines rule access types
 *
 * @enum
 * @readonly
 */
const RuleAccessTypes = Object.create(Enum, {
  RECURRING: { value: 'rule_access_recurring', enumerable: true },
  TEMPORARY: { value: 'rule_access_temporary', enumerable: true },
  ALWAYS: { value: 'rule_access_always', enumerable: true },
});

exports.RuleAccessTypes = RuleAccessTypes;
